import React, { useState } from 'react'
import AdminHeader from './AdminHeader.js'
import NoDataFound from '../components/NoDataFound.js'
import { useQuery } from '@apollo/client'
import { GET_NETAMOUNT, GETNETAMOUNT, GETTURNOVER } from '../graphql/Query/Order.js'
import CustomPagination from '../components/Pagination.js'
import useScrollToTop from '../components/useScrollToTop.js';



const AdminIncome = () => {
  useScrollToTop();

  const { data } = useQuery(GETTURNOVER);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(200);
  const [searchUser, setSearchUser] = useState('');
  const [toDate, setToDate] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [filter, setFilter] = useState('');
  const { data: getNetAMount } = useQuery(GET_NETAMOUNT);
  const { data: getNetIncome, loading, error, refetch } = useQuery(GETNETAMOUNT, {
    variables: {
      page: page + 1,
      limit,
      sort: {
        key: "createdAt",
        type: -1
      },
      filter: filter,
      from: fromDate,
      to: toDate,
    }
  });



  const fromDateChange = (e) => {
    setFromDate(e.target.value);
  }
  const toDateChange = (e) => {
    setToDate(e.target.value)
  }
  const searchCustomerUser = () => {
    setFilter(searchUser)
  }
  const handleSearch = (e) => {
    searchCustomerUser()
  }

  const handleReset = () => {
    setFromDate('');
    setToDate('');
    setFilter('');
    setSearchUser('');
  }
  const handlePageClick = (selectedPage) => {
    setPage(selectedPage);
  };
  return (
    <div>
      <AdminHeader />
      <div className='mx-auto max-w-auto px-6 lg:px-8 my-10 space-y-7'>
        <div className="grid grid-cols-4 gap-4">
          {/* Net Turnover Card */}
          <div className="bg-white rounded-lg p-6 border border-slate-300">
            <h3 className="text-lg font-semibold text-gray-700">Net Turnover</h3>
            <div className="mt-3 space-y-2 text-gray-600 text-sm">
              <p>Today: <span className="font-medium">{data?.orderAmountTotals?.dailyTotal}</span></p>
              <p>Month: <span className="font-medium">{data?.orderAmountTotals?.monthlyTotal}</span></p>
              <p>Year: <span className="font-medium">{data?.orderAmountTotals?.yearlyTotal}</span></p>
            </div>
            {/* <hr className="my-4 border-gray-300" />
            <p className="text-blue-500 font-medium text-sm cursor-pointer hover:underline">View Details</p> */}
          </div>

          {/* Net Income Card */}
          <div className="bg-white rounded-lg p-6 border border-slate-300">
            <h3 className="text-lg font-semibold text-gray-700">Net Income</h3>
            <p className="text-gray-500 text-sm">(- Third party, - Cashfree)</p>
            <div className="mt-3 space-y-2 text-gray-600 text-sm">
              <p>Today: <span className="font-medium">{getNetAMount?.orderNetAmountTotals?.dailyTotal}</span></p>
              <p>Month: <span className="font-medium">{getNetAMount?.orderNetAmountTotals?.monthlyTotal}</span></p>
              <p>Year: <span className="font-medium">{getNetAMount?.orderNetAmountTotals?.yearlyTotal}</span></p>
            </div>
            {/* <hr className="my-4 border-gray-300" />
            <p className="text-blue-500 font-medium text-sm cursor-pointer hover:underline">View Details</p> */}
          </div>
        </div>


        {/* Filters Section */}
        <div className='p-4 max-w-full mx-auto bg-slate-50 ring-1 ring-gray-200 rounded-xl space-y-4'>
          <div className='flex justify-between'>
            <h2 className="text-lg font-semibold">Pickup Filters</h2>
            <button
              className="px-4 py-1 border border-slate-900 text-slate-900 rounded-md hover:bg-slate-900 hover:text-white bg-white transition-colors duration-300"
              onClick={handleReset}
            >
              Reset
            </button>
          </div>
          <div className='lg:flex space-y-7 lg:space-y-0 lg:justify-between'>
            <div>
              <p className="text-sm font-medium text-gray-700">Search</p>
              <div className='md:flex md:space-x-4 space-x-0'>
                <input type="text" onChange={(e) => setSearchUser(e.target.value)} onKeyDown={handleSearch} value={searchUser} placeholder="Search..." className="mt-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 mb-2 md:mb-0 w-full md:w-none p-1.5 border rounded-md" />
              </div>
            </div>
            <div className='md:flex md:space-x-4 space-x-0 space-y-3 md:space-y-0'>
              <div>
                <p className="text-sm font-medium text-gray-700">From</p>
                <input
                  type="date"
                  className="mt-1 w-full md:w-none px-2 py-1.5 md:py-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md"
                  value={fromDate}
                  onChange={(e) => { fromDateChange(e) }}
                />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-700">To</p>
                <input
                  type="date"
                  className="mt-1 w-full md:w-none px-2 py-1.5 md:py-1 focus:ring-0 focus:ring-inset focus:outline-none focus:ring-slate-600 focus:border-slate-600 border rounded-md"
                  value={toDate}
                  onChange={(e) => toDateChange(e)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm bg-white">
            {/* Summary Section */}
            <div className="flex flex-wrap justify-between p-4 border-b bg-slate-50">
              <p className="font-medium text-sm text-gray-700">
                Third Party: <span className="font-semibold">{getNetIncome?.GetOrderWithNetAmount?.ThirdPartyNetAmount}</span>
              </p>
              <p className="font-medium text-sm text-gray-700">
                Payment Gateway: <span className="font-semibold">{getNetIncome?.GetOrderWithNetAmount?.ThirdCashFreeNetAmount}</span>
              </p>
              <p className="font-medium text-sm text-gray-700">
                Total Amount: <span className="font-semibold">{getNetIncome?.GetOrderWithNetAmount?.TotalTurnOver}</span>
              </p>
              <p className="font-medium text-sm text-gray-700">
                Net Income: <span className="font-semibold">{getNetIncome?.GetOrderWithNetAmount?.totalNetAmount}</span>
              </p>
            </div>

            {/* Table */}
            {getNetIncome?.GetOrderWithNetAmount?.orders.length > 0 ? (
              <table className="w-full bg-white">
                <thead className="bg-slate-100 border-b">
                  <tr className="text-left text-gray-600">
                    <th className="py-3 px-4 text-sm font-semibold">No.</th>
                    <th className="py-3 px-4 text-sm font-semibold">Date</th>
                    <th className="py-3 px-4 text-sm font-semibold">AWB No.</th>
                    <th className="py-3 px-4 text-sm font-semibold">Shipment %</th>
                    <th className="py-3 px-4 text-sm font-semibold">Third Party (Rs.)</th>
                    <th className="py-3 px-4 text-sm font-semibold">Payment Gateway (Rs.)</th>
                    <th className="py-3 px-4 text-sm font-semibold">Total Amount (Rs.)</th>
                    <th className="py-3 px-4 text-sm font-semibold">Net Income (Rs.)</th>
                  </tr>
                </thead>
                <tbody>
                  {getNetIncome?.GetOrderWithNetAmount?.orders.map((order, index) => (
                    <tr key={index} className="border-b hover:bg-slate-50">
                      <td className="py-3 px-4 text-sm text-gray-700">{page * limit + index + 1}</td>
                      <td className="py-3 px-4 text-sm text-gray-700">{new Date(order.createdAt).toLocaleDateString()}</td>
                      <td className="py-3 px-4 text-sm text-gray-700">{order.awb_number}</td>
                      {/* <td className="py-3 px-4 text-sm text-gray-700">{order.order_percentage}%</td> */}
                      <td className="py-3 px-4 text-sm text-gray-700">{order.thirdPartyAmount}</td>
                      <td className="py-3 px-4 text-sm text-gray-700">{order.cashFreeAmount}</td>
                      <td className="py-3 px-4 text-sm text-gray-700">{order.order_amount}</td>
                      <td className="py-3 px-4 text-sm font-semibold text-green-600">{order.netAmount}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="flex justify-center items-center h-full min-h-[300px]">
                <NoDataFound />
              </div>
            )}

            {/* Pagination */}
            {data?.GetOrderWithNetAmount?.count > 0 && (
              <div className="flex justify-end p-4 border-t bg-slate-50">
                <CustomPagination
                  totalItems={data?.GetOrderWithNetAmount?.count || 0}
                  limit={limit}
                  pageNo={page}
                  handlePageClick={handlePageClick}
                />
              </div>
            )}
          </div>
        </div>

      </div>
    </div>
  )
}

export default AdminIncome;